<template>
  <div class="page-wrapper">
    <menu-dispatcher></menu-dispatcher>

    <div class="wrapper">
      <header-dispatcher></header-dispatcher>
      <div class="screen-container">
        <div class="center-content">
          <div class="content-box">
            <div class="content-head">
              <div class="title">
                <router-link to="/directories/garbage-removal">
                  <a class="back" title="Назад"><img src="../image/back.png"></a>
                </router-link>
                {{ isNew ? 'Добавить' : 'Редактировать' }}
              </div>
              <div class="cabinet-body"></div>
            </div>
            <div class="content-body directorys-page">
              <div class="cabinet-info">
                <div class="directory-box">
                  <div class="main-content">
                    <div class="head-panel visibility">
                      <span class="table-string-delete" v-show="!isNew" @click="remove"><i class="fa fa-trash-o"></i>Удалить строку</span>
                    </div>
                    <div class="form">
                      <div class="fieldset">
                        <label class="fieldset-title">Наименование категории</label>
                        <fieldset :class="{'fieldset-error': errors.has('name')}">
                          <input type="text" v-model="name"
                                 v-validate="'required'" :class="{'input': true}" name="name">
                          <span v-show="errors.has('name')" class="error-text">Заполните обязательное поле</span>
                        </fieldset>
                      </div>
                      <div class="fieldset">
                        <label class="fieldset-title">Стоимость суток, руб.</label>
                        <fieldset :class="{'fieldset-error': errors.has('price')}">
                          <input type="number" v-model="price"
                                 v-validate="'required'" :class="{'input': true}" name="price">
                          <span v-show="errors.has('price')" class="error-text">Заполните обязательное поле</span>
                        </fieldset>
                      </div>
                      <div class="fieldset">
                        <label class="fieldset-title">Стоимость доп. суток, руб.</label>
                        <fieldset :class="{'fieldset-error': errors.has('addPrice')}">
                          <input type="number" v-model="addPrice"
                                 v-validate="'required'" :class="{'input': true}" name="addPrice">
                          <span v-show="errors.has('addPrice')" class="error-text">Заполните обязательное поле</span>
                        </fieldset>
                      </div>
                      <div class="fieldset">
                        <label class="fieldset-title">Зар. плата, руб.</label>
                        <fieldset :class="{'fieldset-error': errors.has('salary')}">
                          <input type="number" v-model="salary"
                                 v-validate="'required'" :class="{'input': true}" name="salary">
                          <span v-show="errors.has('salary')" class="error-text">Заполните обязательное поле</span>
                        </fieldset>
                      </div>
                      <div class="fieldset">
                        <label class="fieldset-title">Зар. плата за доп. сутки, руб.</label>
                        <fieldset :class="{'fieldset-error': errors.has('addSalary')}">
                          <input type="number" v-model="addSalary"
                                 v-validate="'required'" :class="{'input': true}" name="addSalary">
                          <span v-show="errors.has('addSalary')" class="error-text">Заполните обязательное поле</span>
                        </fieldset>
                      </div>
                      <div class="cashless-block">
                        <div class="fieldset">
                          <div class="title">Надбавка за безнал</div>
                        </div>
                        <div class="fieldset">
                          <label class="fieldset-title">Надбавка за сутки, руб.</label>
                          <fieldset :class="{'fieldset-error': errors.has('priceSurchargeByCashless')}">
                            <input type="number" v-model="priceSurchargeByCashless"
                                   v-validate="'required'" :class="{'input': true}" name="priceSurchargeByCashless">
                            <span v-show="errors.has('priceSurchargeByCashless')" class="error-text">Заполните обязательное поле</span>
                          </fieldset>
                        </div>
                      </div>
                      <div class="buttons">
                        <button type="button" class="save-button" @click="save">Сохранить</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
    import MenuDispatcher from '@/components/MenuDispatcher.vue'
    import HeaderDispatcher from '@/components/HeaderDispatcher.vue'
    import api from '@/api'
    import VeeValidate from 'vee-validate'

    export default {
  name: 'GarbageRemovalCategory',
  components: {
    MenuDispatcher,
    HeaderDispatcher,
    VeeValidate
  },

  data () {
    return {
      id: null,
      isNew: false,
      garbageCategory: {},
      newGarbageCategory: {}
    }
  },

  computed: {
    name: {
      get () {
        return !this.isNew ? this.garbageCategory.name : this.newGarbageCategory.name
      },

      set (name) {
        !this.isNew ? this.garbageCategory.name = name : this.newGarbageCategory.name = name
      }
    },
    price: {
      get () {
        return !this.isNew ? this.garbageCategory.price : this.newGarbageCategory.price
      },

      set (price) {
        !this.isNew ? this.garbageCategory.price = price : this.newGarbageCategory.price = price
      }
    },
    addPrice: {
      get () {
        return !this.isNew ? this.garbageCategory.addPrice : this.newGarbageCategory.addPrice
      },

      set (addPrice) {
        !this.isNew ? this.garbageCategory.addPrice = addPrice : this.newGarbageCategory.addPrice = addPrice
      }
    },
    salary: {
      get () {
        return !this.isNew ? this.garbageCategory.salary : this.newGarbageCategory.salary
      },

      set (salary) {
        !this.isNew ? this.garbageCategory.salary = salary : this.newGarbageCategory.salary = salary
      }
    },
    addSalary: {
      get () {
        return !this.isNew ? this.garbageCategory.addSalary : this.newGarbageCategory.addSalary
      },

      set (addSalary) {
        !this.isNew ? this.garbageCategory.addSalary = addSalary : this.newGarbageCategory.addSalary = addSalary
      }
    },

    priceSurchargeByCashless: {
      get () {
        return !this.isNew ? this.garbageCategory.priceSurchargeByCashless : this.newGarbageCategory.priceSurchargeByCashless
      },

      set (priceSurchargeByCashless) {
        !this.isNew ? this.garbageCategory.priceSurchargeByCashless = priceSurchargeByCashless
          : this.newGarbageCategory.priceSurchargeByCashless = priceSurchargeByCashless
      }
    }
  },

  mounted () {
    let body = document.getElementsByTagName('body')[0]
    body.classList.add('cabinet-page')

    this.id = this.$route.params.id
    if (this.id == 'new') {
      this.isNew = true
      this.newGarbageCategory = {
        name: null,
        price: null,
        addPrice: null,
        salary: null,
        addSalary: null,
        priceSurchargeByCashless: null
      }
    } else {
      api
        .getGarbageRemovalCategoryById(this.id)
        .then(garbageCategory => {
          if (garbageCategory) {
            this.garbageCategory = garbageCategory
            this.isNew = false
          }
        })
    }
  },

  destroyed () {
    let body = document.getElementsByTagName('body')[0]
    body.classList.remove('cabinet-page')
  },

  methods: {
    remove () {
      this.garbageCategory.removed = true
      this.save()
    },

    save () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.$store.getters.waitingApiRequestsCount != 0) { return }

          this.isNew
            ? api
              .createGarbageRemovalCategory(this.newGarbageCategory)
              .then(() => {
                this.$router.push('/directories/garbage-removal')
                alert('Сохранено')
              })
              .catch(err => alert(err))
            : api
              .updateGarbageRemovalCategory(this.id, this.garbageCategory)
              .then(() => {
                this.$router.push('/directories/garbage-removal')
                alert('Сохранено')
              })
              .catch(err => alert(err))
        }
      })
    }
  }
}
</script>
